'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NavigationArrowBack = function NavigationArrowBack(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z' })
  );
};
NavigationArrowBack = (0, _pure2.default)(NavigationArrowBack);
NavigationArrowBack.displayName = 'NavigationArrowBack';
NavigationArrowBack.muiName = 'SvgIcon';

exports.default = NavigationArrowBack;


/*****************
 ** WEBPACK FOOTER
 ** ./~/material-ui/svg-icons/navigation/arrow-back.js
 ** module id = 2244
 ** module chunks = 0
 **/